const accordionData = [
  {
    title: 'Can I start as a beginner?',
    content: `Yes! My school is open to students of all levels, so please don't be afraid if you are just starting out!`,
  },
]

export default accordionData
